var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"top","popper-class":"py-1 px-2"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_vm._v(_vm._s(_vm.message))]),_c('i',{staticClass:"fa fa-warning text-warning ml-2"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }